import React from 'react';
import { ISocialIcon, ISocialIconProps } from './SocialIcon';

export const FacebookIcon: ISocialIcon = React.forwardRef<SVGSVGElement, ISocialIconProps>((props, ref) => (
  <svg className={props.className} width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M16.7998 0.835505C8.45554 0.813644 1.50329 7.22407 0.849512 15.5427C0.195736 23.8614 6.0612 31.2792 14.3064 32.5611V21.4008H10.2572V16.793H14.3064V13.2724C14.3064 9.28303 16.6901 7.06892 20.2905 7.06892C21.4866 7.0854 22.6799 7.18873 23.861 7.3781V11.3076H21.8663C21.1758 11.2235 20.4841 11.456 19.9845 11.9401C19.4849 12.4242 19.2308 13.1081 19.2932 13.801V16.793H23.7214L23.0133 21.4008H19.2932V32.5611C27.5384 31.2792 33.4039 23.8614 32.7501 15.5427C32.0963 7.22407 25.1441 0.813644 16.7998 0.835505Z"
    ></path>
  </svg>
));
FacebookIcon.displayName = 'FacebookIcon';
